import { isDebugModeEnabled } from 'es6/controllers/apps/debug-overrides';
import SentenceQuizBase from 'es6/controllers/apps/quizzes/sentence-quiz-base';

/**
 * Base class for the fill in the blank sentence quizzes.
 */
export class SentenceStudyListeningFillInTheBlankBase extends SentenceQuizBase {
  constructor(...args) {
    super(...args);

    // Define in subclass class.
    this._mode = null;
  }

  /**
   * Callback for submitting on the quiz screen.
   *
   * @param {Boolean} isCorrect
   * @param {String}  enteredText
   * @param {Number}  hintsUsed
   * @param {Number}  mistakes
   */
  _handleSubmit(isCorrect, enteredText, hints, mistakes, fillInTheBlankHTML) {
    this._isCorrect = isCorrect;
    this._hints = hints;
    this._mistakes = mistakes;
    this._fillInTheBlankHTML = fillInTheBlankHTML;

    // Set the appropriate quiz result.
    this._setQuizResult(enteredText);

    // Update meta data and start next phase.
    this.updateQuizData({ enteredText, hintsUsed: hints });

    // If the quiz is over, start the confirmation phase. Otherwise,
    // create a new quiz result.
    if (isCorrect || mistakes === this._getMaxMistakes()) {
      this.result.beginPhase('confirmation');
      this._showConfirmationScreen();
    } else {
      this._pushQuizResult();
    }
  }

  /**
   * Renders the confirmation screen.
   *
   * @override
   */
  _showConfirmationScreen() {
    const props = {
      isCorrect:    this._isCorrect,
      maxMistakes:  this._getMaxMistakes(),
      mistakes:     this._mistakes,
      onNext:       this.finishQuiz.bind(this),
      sentence:     this._sentence,
      fillInTheBlankHTML: this._fillInTheBlankHTML,
    };

    this._screenManager.populateAndShow('dictation_confirmation', props);
  }

  /**
   * Renders or rerenders the quiz screen.
   *
   * @override
   */
  _showQuizScreen() {
    const props = {
      debugMode:    isDebugModeEnabled(),
      maxHints:     this._getMaxHints(),
      maxMistakes:  this._getMaxMistakes(),
      mode:         this._mode,
      onDontKnow:   this._handleDontKnow.bind(this),
      onSubmit:     this._handleSubmit.bind(this),
      sentence:     this._sentence,
    };

    this._screenManager.populateAndShow('dictation_quiz', props);
  }

  /**
   * Renders the recall screen.
   *
   * @override
   */
  _showRecallScreen() {
    const props = {
      mode:       this._mode,
      onDontKnow: this._handleDontKnow.bind(this),
      onNext:     this._handleRecallNext.bind(this),
      sentence:   this._sentence,
    };

    this._screenManager.populateAndShow('dictation_recall', props);
  }
}

export default SentenceStudyListeningFillInTheBlankBase;
